<template>
  <div class="report-container">
    <component
      :is="getComponent(report_type)"
      :id="`current-report`"
      :survey_status="survey_status"
      :get_current_status="get_current_status"
    />
  </div>
</template>

<script>
import { REPORT_TYPES } from '../report.constants'

import Stats from './Stats'
import Reports from './Reports'
import Database from './Database'
import Exports from './Exports'

export default {
  name: 'ReportTypeRenderer',

  components: {
    Stats,
    Reports,
    Database,
    Exports,
  },

  data() {
    return {}
  },

  props: {
    report_type: {
      required: true,
      type: String,
    },
    survey_status: {
      required: true,
      type: Object,
    },
    get_current_status: {
      required: true,
      type: Function,
    },
  },

  methods: {
    getComponent(type) {
      switch (type) {
        case REPORT_TYPES.STATS:
          return 'Stats'
        case REPORT_TYPES.REPORTS:
          return 'Reports'
        case REPORT_TYPES.DATABASE:
          return 'Database'
        case REPORT_TYPES.EXPORTS:
          return 'Exports'
        default:
          throw new Error(`${type} is not a valid Report type`)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.report-container {
  margin-top: 40px;
}
</style>
